import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../services/AuthContext';

const DashboardView = () => {
  const { user, isAuthenticated } = useAuth();

  if (!isAuthenticated()) {
    return (
      <div className="container" style={{ padding: '2rem 0' }}>
        <div className="card">
          <div className="card-body text-center">
            <h2>Access Denied</h2>
            <p>Please login to access the dashboard.</p>
            <Link to="/auth" className="btn btn-primary">Login</Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="dashboard">
      <div className="container" style={{ padding: '2rem 0' }}>
        <div className="mb-8">
          <h1 style={{ fontSize: '2rem', fontWeight: '600', marginBottom: '0.5rem' }}>
            Welcome, {user?.profile?.firstName} {user?.profile?.lastName}
          </h1>
          <p style={{ color: 'var(--text-light)' }}>
            {user?.role === 'ADMIN' ? 'College Administrator Dashboard' : 'Company Verifier Dashboard'}
          </p>
        </div>

        {user?.role === 'ADMIN' ? (
          <div className="grid grid-cols-2 gap-6">
            <div className="card">
              <div className="card-body text-center">
                <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>📝</div>
                <h3 className="card-title">Issue New Certificate</h3>
                <p style={{ color: 'var(--text-light)', marginBottom: '1.5rem' }}>
                  Enter student details to issue a new blockchain certificate
                </p>
                <Link to="/issue" className="btn btn-primary">
                  Issue Certificate
                </Link>
              </div>
            </div>

            <div className="card">
              <div className="card-body text-center">
                <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>📋</div>
                <h3 className="card-title">My Certificates</h3>
                <p style={{ color: 'var(--text-light)', marginBottom: '1.5rem' }}>
                  View and manage all issued certificates
                </p>
                <Link to="/my-certificates" className="btn btn-primary">
                  View Certificates
                </Link>
              </div>
            </div>
          </div>
        ) : (
          <div className="grid grid-cols-2 gap-6">
            <div className="card">
              <div className="card-body text-center">
                <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>🔍</div>
                <h3 className="card-title">Verify Certificate</h3>
                <p style={{ color: 'var(--text-light)', marginBottom: '1.5rem' }}>
                  Verify employee certificates using ID or QR code
                </p>
                <Link to="/verify" className="btn btn-primary">
                  Verify Now
                </Link>
              </div>
            </div>

            <div className="card">
              <div className="card-body text-center">
                <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>📊</div>
                <h3 className="card-title">Verification History</h3>
                <p style={{ color: 'var(--text-light)', marginBottom: '1.5rem' }}>
                  View your certificate verification history
                </p>
                <Link to="/verification-history" className="btn btn-primary">
                  View History
                </Link>
              </div>
            </div>
          </div>
        )}

        <div className="card" style={{ marginTop: '2rem' }}>
          <div className="card-body">
            <h3 className="card-title">Quick Stats</h3>
            <div className="grid grid-cols-3 gap-4" style={{ marginTop: '1rem' }}>
              <div className="text-center">
                <div style={{ fontSize: '2rem', fontWeight: '600', color: 'var(--primary)' }}>0</div>
                <div style={{ fontSize: '0.9rem', color: 'var(--text-light)' }}>
                  {user?.role === 'ADMIN' ? 'Certificates Issued' : 'Certificates Verified'}
                </div>
              </div>
              <div className="text-center">
                <div style={{ fontSize: '2rem', fontWeight: '600', color: 'var(--primary)' }}>0</div>
                <div style={{ fontSize: '0.9rem', color: 'var(--text-light)' }}>This Month</div>
              </div>
              <div className="text-center">
                <div style={{ fontSize: '2rem', fontWeight: '600', color: 'var(--primary)' }}>100%</div>
                <div style={{ fontSize: '0.9rem', color: 'var(--text-light)' }}>Success Rate</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardView;